export default {
  section_title: 'Moneda',
  label: 'Moneda',
  tooltip:
    'La moneda que usan tus precios, pagos e informes. Se configura para tu cuenta de socio al crearla y no se puede cambiar aquí; contacta a soporte si es incorrecta.',
  from_your_partner: 'De tu socio',
  set_for_your_account: 'Configurado para tu cuenta',
};
